"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activityTypes = void 0;
var activityTypes;
(function (activityTypes) {
    activityTypes["EMAIL"] = "email";
    activityTypes["LETTER"] = "letter";
    activityTypes["OUTGOING_SMS"] = "outgoingSms";
    activityTypes["INCOMING_SMS"] = "incomingSms";
    activityTypes["OUTGOING_CALL"] = "outgoingCall";
    activityTypes["INCOMING_CALL"] = "incomingCall";
    activityTypes["PUSH_NOTIFICATION"] = "pushNotification";
    activityTypes["TEST_RESULT"] = "testResult";
    activityTypes["KIT_SHIPMENT"] = "kitShipment";
    activityTypes["NOTE"] = "note";
    activityTypes["PRIORITIZED"] = "prioritized";
    activityTypes["APP_VERIFICATION"] = "appVerification";
    activityTypes["SUPPORT_TICKET"] = "supportTicket";
    activityTypes["PCP_NAME_CONFIRMATION"] = "pcpNameConfirmation";
    activityTypes["PCP_NPI_CONFIRMATION"] = "pcpNpiConfirmation";
    activityTypes["PCP_FAX_CONFIRMATION"] = "pcpFaxConfirmation";
    activityTypes["RESULTS_DELIVERY_TO_DOCTOR"] = "resultsDeliveryToDoctor";
})(activityTypes || (exports.activityTypes = activityTypes = {}));
